import PopupComponent, { Header, IPopupProps } from '@components/std-components/Popup'
import Typography from '@components/std-components/Typography'
import React, { FC, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import CreateCopyTemplateForm, {
  CreateCopyTemplateFormProps
} from './CreateCopyTemplateForm'
import EnCross from '@meronex/icons/en/EnCross'

export interface CreateCopyTemplateFormPopupProps
  extends CreateCopyTemplateFormProps,
    Pick<IPopupProps, 'open' | 'onClose'> {}

const CreateCopyTemplatePopup: FC<CreateCopyTemplateFormPopupProps> = ({
  open,
  onClose,
  onCancel,
  ...formProps
}) => {
  const { t } = useTranslation()
  const ref = useRef<any>()
  return (
    <PopupComponent ref={ref} open={open} onClose={onClose} contentStyle={{ width: 540 }}>
      <Header>
        <div className='flex justify-space-between align-center'>
          <Typography variant='toolBarTitle'>
            {t(
              'order.quantitiesAndBook.modal.copy.title',
              'Copy to create quantities template'
            )}
          </Typography>
          <div onClick={() => ref?.current?.close()}>
            <EnCross size={24} />
          </div>
        </div>
      </Header>
      <CreateCopyTemplateForm
        {...formProps}
        onCancel={() => {
          ref?.current?.close()
          onCancel?.()
        }}
      />
    </PopupComponent>
  )
}

export default CreateCopyTemplatePopup
